export const SET_SAVED_FILTERS = 'setSavedFilters'
export const ADD_SAVED_FILTER = 'AddSavedFilter'
export const SET_DATE_FILTERS = 'setDateFilters'
export const RESET_FILTER_STATE = 'resetFilterState'
export const SET_FILTERS_META = 'setFiltersMeta'
export const ADD_FILTER = 'addFilter'
export const SET_FILTERS = 'setFilters'
